module.exports = __webpack_public_path__ + "img/51626530_L.e8930218.png";